import React from 'react';
import { bool, shape, string } from 'prop-types';

const InReviewColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#0071CD',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.33366 1.16675H11.667C12.3087 1.16675 12.8337 1.69175 12.8337 2.33341V9.33342C12.8337 9.97508 12.3087 10.5001 11.667 10.5001H3.50033L1.16699 12.8334L1.17283 2.33341C1.17283 1.69175 1.69199 1.16675 2.33366 1.16675ZM3.01616 9.33342H11.667V2.33341H2.33366V10.0159L3.01616 9.33342ZM6.12533 8.16675H10.5003V7.00008H7.29199L6.12533 8.16675ZM8.37699 4.32841C8.49366 4.44508 8.49366 4.62592 8.37699 4.74258L4.94116 8.16675H3.50033V6.72592L6.93033 3.29591C7.04699 3.17925 7.22783 3.17925 7.34449 3.29591L8.37699 4.32841Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
  </svg>
);

InReviewColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default InReviewColor;
